<template>
  <jet-form-section @submitted="updateBilling">
    <template #title>Linked Accounts</template>

    <template #description>
      Settings for My Trucks
    </template>

    <template #form>
      <jet-action-message :on="form.recentlySuccessful">Saved.</jet-action-message>


      <template v-for="linked in $page.props.auth.user.linked_session.linked">
          <h3>{{ linked.company_name }} </h3>

          <div class="form-row">
            <label for="mtd_shared_stripe_cc_emails_switch" class="col-sm-4">Copy Me on Emails</label>
            <InputSwitch v-model="linked.mtd_shared_stripe_cc_emails" inputId="mtd_shared_stripe_cc_emails_switch" @change="toggleEmails(linked)"/> 
          </div>
          <hr/>
      </template>

    </template>

  </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

import PaymentMethodUpdate from '@/Components/Payment/PaymentMethodUpdate'
import InputSwitch from 'primevue/inputswitch';

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    PaymentMethodUpdate,
    InputSwitch,
  },

  props: ['payment', 'has_linked',],

  data() {
    return {
      form: this.$inertia.form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
    }
  },

  methods: {
    updateBilling() {
    },
      toggleEmails(linked) {
        this.cardProcessing = true
        this.$inertia.visit(route('mtd.linked.toggleemail', linked), {
          preserveScroll: true
        })
      }
  },
}
</script>
